import Cookies from "js-cookie";

export interface OfferTypes {
  isHVO: boolean;
  is2MonthFree: boolean;
  is3MonthFree: boolean;
  isRVO: boolean;
  isHVOTest: boolean;
}

export const DEFAULT_ADDRESS_OFFER_TYPE = "default";

function compareOfferTypeFromString(keyWord: string, addressOfferType: string): boolean {
  return normalizeOfferCode(addressOfferType).includes(normalizeOfferCode(keyWord));
}

/** Pure: derive flags from a cookie / cohort string (no `window` / Cookies). */
export const computeOfferTypesFromAddressOfferType = (addressOfferType: string): OfferTypes => {
  const value = addressOfferType || DEFAULT_ADDRESS_OFFER_TYPE;
  const isHVO = compareOfferTypeFromString("High Value Offer", value);
  const is3MonthFree = compareOfferTypeFromString("3 Months on Us", value);
  const is2MonthFree = compareOfferTypeFromString("2 Months on Us", value);
  const isRVO = compareOfferTypeFromString("ReturnVisitor", value);
  const isHVOTest = isHVO && compareOfferTypeFromString("Test", value);

  return {
    is3MonthFree,
    is2MonthFree,
    isHVO,
    isRVO,
    isHVOTest,
  };
};

export const resolveAddressOfferType = (
  addressOfferType: string | undefined,
  offerTypes?: OfferTypes
): string | undefined => {
  const types = offerTypes ?? computeOfferTypesFromAddressOfferType(addressOfferType ?? DEFAULT_ADDRESS_OFFER_TYPE);
  const { is3MonthFree, is2MonthFree, isRVO, isHVO, isHVOTest } = types;

  if (is3MonthFree) return "3monthfree";
  if (is2MonthFree) return "2monthfree";
  if (isRVO) return "RVO";
  if (isHVOTest) return "HVOTest";
  if (isHVO) return "addressCohort";

  return addressOfferType;
};

export const getOfferTypes = (): OfferTypes =>
  computeOfferTypesFromAddressOfferType(
    typeof window !== "undefined"
      ? Cookies.get("addressOfferType") ?? DEFAULT_ADDRESS_OFFER_TYPE
      : DEFAULT_ADDRESS_OFFER_TYPE
  );

export const normalizeOfferCode = (code: string | undefined): string => {
  if (!code) return "";
  const normalizedCode = code.toLowerCase().trim().replace(/\s+/g, "");
  return normalizedCode ?? "";
};
